import type { PageableRequest } from '../types';

export type EducationClass = {
  id: number;
  litera: string;
  parallel: Parallel;
  shift: SHIFT;
  includeSaturday: boolean;
  saturdayMorningShift: boolean;
};

export enum Parallel {
  FIRST = 'FIRST',
  SECOND = 'SECOND',
  THIRD = 'THIRD',
  FOURTH = 'FOURTH',
  FIFTH = 'FIFTH',
  SIXTH = 'SIXTH',
  SEVENTH = 'SEVENTH',
  EIGHTH = 'EIGHTH',
  NINTH = 'NINTH',
  TENTH = 'TENTH',
  ELEVENTH = 'ELEVENTH',
}

export enum SHIFT {
  MORNING = 'MORNING',
  AFTERNOON = 'AFTERNOON',
}

export type CreateEducationClassBody = Omit<EducationClass, 'id'>;
export type UpdateEducationClassBody = EducationClass;

export type EducationsClassFilters = {
  name?: string;
  litera?: string;
  parallel?: Parallel;
  curriculumId?: number;
  includeSaturday?: boolean;
};

export type EducationClassListRequest = PageableRequest<EducationClass> & EducationsClassFilters;
